import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { toast } from "react-toastify";
import {
  createMedia,
  updateMedia,
  deleteMedia,
} from "../../features/admin/MediaSlice";

const getUserPermissions = () => {
  const permissions = localStorage.getItem("permissions");
  return permissions
    ? JSON.parse(permissions).map((p) => p.permissionSlug)
    : [];
};

const userId = localStorage.getItem("userId");
const hasPermission = (requiredPermission) => {
  if (userId == 1) {
    return true;
  }
  const userPermissions = getUserPermissions();
  return userPermissions.includes(requiredPermission);
};

const videoSchema = Yup.object().shape({
  title: Yup.string().required("Vui lòng nhập tiêu đề"),
  videoUrl: Yup.string()
    .url("Vui lòng nhập đường dẫn hợp lệ")
    .required("Vui lòng nhập đường dẫn video"),
});

const VideoModal = ({ media, onClose }) => {
  const [title, setTitle] = useState(media ? media.title : "");
  const [videoUrl, setVideoUrl] = useState(media ? media.url : "");
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const { error: apiError } = useSelector((state) => state.medias);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await videoSchema.validate({ title, videoUrl });
      setIsLoading(true);
      const formData = { title, videoUrl, imageableId: userId };
      const res = media
        ? await dispatch(updateMedia({ id: media.id, data: formData }))
        : await dispatch(createMedia(formData));
      if (res.meta.requestStatus === "fulfilled") {
        toast.success(
          media ? "Cập nhật video thành công!" : "Thêm video thành công!"
        );
        onClose();
      }
    } catch (validationError) {
      setError(validationError.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!media) return;
    setIsLoading(true);
    await dispatch(deleteMedia(media.id));
    toast.success("Xóa video thành công!");
    onClose();
    // if (res.meta.requestStatus === "fulfilled") {
    //   toast.success("Xóa video thành công!");
    //   onClose();
    // } else {
    //   toast.error("Xóa không thành công!");
    // }
    setIsLoading(false);
  };

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center">
      <div className="bg-base-100 p-6 rounded-lg w-96 max-h-[90vh] overflow-y-auto shadow-lg">
        <h2 className="text-xl font-semibold mb-4">
          {media ? "Chi tiết video" : "Thêm video"}
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium">
              Tiêu đề<i className="text-red-600"> *</i>
            </label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="input input-bordered w-full"
              disabled={isLoading}
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium">
              Đường dẫn video<i className="text-red-600"> *</i>
            </label>
            <input
              type="text"
              value={videoUrl}
              onChange={(e) =>
                setVideoUrl(e.target.value?.replace(/&ab_channel=[^&]*/, ""))
              }
              className="input input-bordered w-full"
              disabled={isLoading}
            />
          </div>
          {videoUrl && (
            <div className="mt-2 flex justify-center">
              <iframe
                width="100%"
                height="200"
                src={videoUrl
                  .replace("watch?v=", "embed/")
                  ?.replace(/&ab_channel=[^&]*/, "")}
                title="Video Preview"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          )}
          {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
          <div className="flex justify-between mt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded btn btn-sm"
              disabled={isLoading}
            >
              Đóng
            </button>
            {media ? (
              <>
                {hasPermission("MEDIA_DELETE") && (
                  <button
                    type="button"
                    onClick={handleDelete}
                    className="px-4 py-2 btn btn-error rounded btn-sm"
                    disabled={isLoading}
                  >
                    {isLoading ? "Đang xóa..." : "Xóa"}
                  </button>
                )}
                {hasPermission("MEDIA_UPDATE") && (
                  <button
                    type="submit"
                    className="px-4 py-2 btn btn-primary btn-sm rounded"
                    disabled={isLoading}
                  >
                    {isLoading ? "Đang lưu..." : "Lưu"}
                  </button>
                )}
              </>
            ) : (
              <button
                type="submit"
                className="px-4 py-2 btn btn-primary btn-sm rounded"
                disabled={isLoading}
              >
                {isLoading ? "Đang lưu..." : "Lưu"}
              </button>
            )}
          </div>
          {apiError && (
            <p className="text-red-500 text-sm mt-2">
              Đã xảy ra lỗi: {apiError.message}
            </p>
          )}
        </form>
      </div>
    </div>
  );
};

export default VideoModal;
